module.exports = __webpack_public_path__ + "static/media/rebozos.b742ecfe.jpg";